import { render, staticRenderFns } from "./MRC_ESS_Taber.vue?vue&type=template&id=3a129467&scoped=true&"
import script from "./MRC_ESS_Taber.vue?vue&type=script&lang=js&"
export * from "./MRC_ESS_Taber.vue?vue&type=script&lang=js&"
import style0 from "./MRC_ESS_Taber.vue?vue&type=style&index=0&id=3a129467&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a129467",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBadge,VCard,VCardText,VContainer,VDivider,VProgressCircular,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a129467')) {
      api.createRecord('3a129467', component.options)
    } else {
      api.reload('3a129467', component.options)
    }
    module.hot.accept("./MRC_ESS_Taber.vue?vue&type=template&id=3a129467&scoped=true&", function () {
      api.rerender('3a129467', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MRC_ESS_Taber.vue"
export default component.exports